'use client';

import Header from '@/components/common/Header';
import AboutUsInteractive from './components/AboutUsInteractive';
import FooterWrapper from '@/components/common/FooterWrapper';

export default function AboutUsPage() {
  return (
    <>
      <Header />
      <AboutUsInteractive />
      <FooterWrapper />
    </>
  );
}